export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11041_CHAT': 'Chat',
    '_11159_ENTER_A_NAME_TO_SEARCH': 'Enter a name to search',
    '_11160_CLOSE_CHAT': 'Close Chat',
    '_11161_MINIMIZE_CHAT': 'Minimize Chat',
    '_11162_MAXIMIZE_CHAT': 'Maximize Chat'
};
